import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';
import { getCategories, saveCategory } from '../actions/categoryLanding';

import Checkbox from '../components/form/Checkbox.jsx';
import Alert from 'react-s-alert';
import HomeNav from '../components/HomeNav.jsx';

const PublishView = () => {
    const [drafts, setDrafts] = React.useState([]);

    React.useEffect(() => {
        (async () => {
            let data = await getCategories();
            let sites = Object.values(data);
            let drafts = sites.flatMap((urls) => {
                return urls.reduce((xacc, url) => {
                    let _drafts = window.localStorage.getItem(url.category_name);
                    if (!_drafts) return xacc;
                    let drafts = JSON.parse(_drafts).map((d, i) => {
                        d._index = i;
                        return d;
                    });

                    return [...xacc, ...drafts];
                }, []);
            });
            setDrafts(drafts);
        })();
    }, []);

    const handleSelect = (index, checked) => {
        setDrafts((drafts) =>
            drafts.map((draft, i) => {
                if (index === i) {
                    draft.selected = checked;
                }
                return draft;
            })
        );
    };

    const handleSelectAll = () => {
        setDrafts((drafts) =>
            drafts.map((draft, i) => {
                draft.selected = true;
                return draft;
            })
        );
    };

    const handleDeSelectAll = () => {
        setDrafts((drafts) =>
            drafts.map((draft, i) => {
                draft.selected = false;
                return draft;
            })
        );
    };

    const handleDeleteDraft = () => {
        drafts
            .filter((d) => d.selected)
            .forEach((draft) => {
                let _newDrafts = drafts.filter((d) => d._index !== draft._index);
                let newDrafts = _newDrafts.filter((d) => d.category_name === draft.category_name);

                saveCategory(draft.category_name.substring(1), draft)
                    .then((resp) => {
                        setDrafts(_newDrafts);
                        window.localStorage.setItem(draft.category_name, JSON.stringify(newDrafts));
                    })
                    .catch(() => {
                        Alert.error('Error Deleting Draft. Please contact Web Dev.');
                    });
            });
    };

    const handlePublish = () => {
        drafts
            .filter((d) => d.selected)
            .forEach((draft) => {
                let _newDrafts = drafts.filter((d) => d._index !== draft._index);
                let newDrafts = _newDrafts.filter((d) => d.category_name === draft.category_name);

                let _draft = draft;
                delete _draft._index;
                delete _draft.updated;
                delete _draft.created;
                delete _draft.selected;

                saveCategory(draft.category_name.substring(1), _draft)
                    .then((resp) => {
                        Alert.success('Published!');
                        setDrafts(_newDrafts);
                        window.localStorage.setItem(draft.category_name, JSON.stringify(newDrafts));
                    })
                    .catch((err) => {
                        console.error(err);
                        Alert.error('Error Publishing. Please contact Web Dev.');
                    });
            });
    };

    let selectedDrafts = drafts.filter((d) => d.selected);

    return (
        <Fragment>
            <HomeNav />
            <div className="container-fixed">
                <h1>Manage Drafts</h1>
                <div className="row">
                    <div className="col-xs-12 col-md-8">
                        <ul className="list-flat">
                            {!drafts.length && <li>No Drafts</li>}
                            {!!drafts.length &&
                                drafts.map((draft, index) => (
                                    <li key={`draft_${draft.category_name}_${index}`}>
                                        <Checkbox
                                            id={`draft_${draft.category_name}_${index}`}
                                            label={
                                                <Link
                                                    to={{
                                                        pathname: '/category',
                                                        search: new URLSearchParams({
                                                            url: draft.category_name,
                                                            draft: draft._index
                                                        }).toString()
                                                    }}
                                                >
                                                    {draft.display_name} ({draft.category_name}) - {draft.draft_name}
                                                </Link>
                                            }
                                            checked={draft.selected || false}
                                            collapse
                                            onChange={(v) => handleSelect(index, v)}
                                        />
                                    </li>
                                ))}
                        </ul>
                    </div>
                    {!!drafts.length && (
                        <div className="col-xs-12 col-md-4">
                            {!selectedDrafts.length ? (
                                <p>
                                    <button type="button" className="button button-full" onClick={handleSelectAll}>
                                        Select All
                                    </button>
                                </p>
                            ) : (
                                <p>
                                    <button type="button" className="button button-full" onClick={handleDeSelectAll}>
                                        Deselect All
                                    </button>
                                </p>
                            )}
                            <p>
                                <button
                                    type="button"
                                    className="button button-success button-full"
                                    onClick={handlePublish}
                                    disabled={!selectedDrafts.length}
                                >
                                    Publish Selected Drafts
                                </button>
                            </p>
                            <p>
                                <button
                                    type="button"
                                    className="button button-danger button-full"
                                    onClick={handleDeleteDraft}
                                    disabled={!selectedDrafts.length}
                                >
                                    Delete Selected Draft
                                </button>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default PublishView;
